<script>
import resources from './resources'

export default {
  name: 'addresses',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(icon='', title='Meus Locais')
    .col-xs-12.content
      .container-fluid.zero-margin
        .row
          card-add(label='Adicionar<br>Novo Local', route='settings.addresses.create', icon='')
          location(@on-delete="doDelete", v-for="address in addresses", :key="address.id", :address="address")
        .pagination
          pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/settings/addresses/index/addresses.vue